module.exports = __webpack_public_path__ + "static/media/PorttraitOfAMan.e8cad606.png";